<template>
    <div>

       <ComIndex  :orderType="6" exportTitle="定制化培训订单"/>

    </div>
</template>

<script>
import ComIndex from '../commonIndex'
export default {
  components: {
    ComIndex
  },
  data () {
    return {

    }
  },
  created () {

  },
  methods: {

  }

}
</script>
<style  scoped>

</style>
